import { svg } from "lit";
const icon = svg `<path d="M7 35.2689V32.9997H40.9999V35.2689H7ZM7 25.1343V22.8651H40.9999V25.1343H7ZM7 14.9997V12.7305H40.9999V14.9997H7Z" fill="currentColor"/>`;
export default icon;
